import React from 'react';

const ListItem = ({ id, textSlot }) => (
    <div class="flex mb-4">
    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" class="text-red-600 w-5 h-5 flex-shrink-0 mr-4" viewBox="0 0 24 24" > {" "} <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>{" "} <path d="M22 4L12 14.01l-3-3"></path>{" "} </svg>
        { textSlot }
    </div>
);

export default ListItem;